"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REVISION_ENTITY_REF_ID_PATTERN = exports.REVISION_SCHEMA_V2 = exports.REVISION_SCHEMA_V1 = void 0;
exports.isRevisionEntityRefId = isRevisionEntityRefId;
exports.REVISION_SCHEMA_V1 = 1;
exports.REVISION_SCHEMA_V2 = 2;
/** Live UUIDs or editor temp ids (`tmp-123`, `tmp-inv-123`, `tmp-ms-1`). */
exports.REVISION_ENTITY_REF_ID_PATTERN = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}|tmp[-_].+)$/i;
function isRevisionEntityRefId(value) {
    return typeof value === "string" && exports.REVISION_ENTITY_REF_ID_PATTERN.test(value);
}
